export class SaharaFailure {
    static CAN_ONLY_REBOUND_ON_BLACK = () => $localize `You can only rebound on dark spaces.`;
    static CAN_ONLY_REBOUND_ON_EMPTY_SPACE = () => $localize `You can only rebound on empty spaces.`;
    static MUST_CHOOSE_PYRAMID_FIRST = () => $localize `You must pick one of your pyramids first.`;
    static MUST_CHOOSE_OWN_PYRAMID = () => $localize `You must pick one of your pyramids.`;
    static THOSE_TWO_SPACES_ARE_NOT_NEIGHBORS = () => $localize `Those two spaces are not neighbors.`;
    static THOSE_TWO_SPACES_HAVE_NO_COMMON_NEIGHBOR = () => $localize `Those two spaces have no intermediary neighbor.`;
}
